import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Nav from "../components/Nav";
import { useSEO } from "../hooks/useSEO";

const Privacy = () => {
  const navigate = useNavigate();
  useSEO(
    "Privacy Policy | Mortgage Survival Playbook 2026",
    "How ENVOLVP LLC handles your data on mortgagesurvivalplaybook.com: minimal collection, Stripe-only payment processing, no tracking, and your data rights."
  );
  return (
    <>
      <Nav />
      <div className="legal-wrap">
        <h1>Privacy Policy</h1>
        <div className="updated">Last updated: 2026 · ENVOLVP LLC</div>
        <p>ENVOLVP LLC ("we", "us") operates mortgagesurvivalplaybook.com. This policy explains how we handle information. We are committed to minimal data collection and full transparency.</p>
        <h2>Information We Collect</h2>
        <p>This website does not use cookies or third-party tracking for advertising. The only personal data processed is what is required to complete a purchase:</p>
        <ul>
          <li>Payment information is processed entirely by <strong>Stripe</strong>. We never see or store your full card or bank details.</li>
          <li>We retain a transaction record (Stripe order ID, amount, timestamp, and completion status) solely to fulfill your license and provide support.</li>
          <li>If you email us, we retain your message to respond to your request.</li>
        </ul>
        <h2>How We Use Information</h2>
        <ul>
          <li>To deliver the licensed product and grant your secure, single-use download.</li>
          <li>To provide 90 days of implementation support.</li>
          <li>To meet legal, accounting, and tax obligations.</li>
        </ul>
        <h2>Payment Processing</h2>
        <p>All payments are handled by Stripe under their own privacy and security terms. We do not sell, rent, or share your personal data with any third party.</p>
        <h2>Data Security</h2>
        <p>Transactions occur over encrypted (SSL/TLS) connections. Download links are single-use and expire after one successful download to protect the licensed material.</p>
        <h2>Your Rights</h2>
        <p>You may request access to, correction of, or deletion of your transaction records by emailing <a href="mailto:hello@mortgagesurvivalplaybook.com">hello@mortgagesurvivalplaybook.com</a>.</p>
        <h2>Contact</h2>
        <p>ENVOLVP LLC, Houston, Texas · <a href="mailto:hello@mortgagesurvivalplaybook.com">hello@mortgagesurvivalplaybook.com</a></p>
        <a className="ty-back" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>← Back to home</a>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
